export default {"src":"/_next/static/media/profile-difficulties.ef5d8ced.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};